var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartpie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 12C2.3999 9.45395 3.41133 7.01215 5.21168 5.2118C7.01203 3.41145 9.45382 2.40002 11.9999 2.40002V12H21.5999C21.5999 14.5461 20.5885 16.9879 18.7881 18.7882C16.9878 20.5886 14.546 21.6 11.9999 21.6C9.45382 21.6 7.01203 20.5886 5.21168 18.7882C3.41133 16.9879 2.3999 14.5461 2.3999 12Z",
    fill: "#0E9F6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 2.70239C16.0603 3.13255 17.5754 3.99893 18.7882 5.21174C20.001 6.42454 20.8673 7.93964 21.2975 9.59999H14.3999V2.70239Z",
    fill: "#0E9F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartpie);
export default __webpack_public_path__ + "static/media/chartpie.0c6078d1bf12df910d33aecc1054c84e.svg";
export { ForwardRef as ReactComponent };